import { Claim } from '@wam/shared';

export function getFromLocalStorage(): Claim[] {
  try {
    return JSON.parse(localStorage.getItem('claims')) || [];
  } catch {
    return [];
  }
}
